import { render, staticRenderFns } from "./addFloorShare.vue?vue&type=template&id=06c117b1&scoped=true"
import script from "./addFloorShare.vue?vue&type=script&lang=js"
export * from "./addFloorShare.vue?vue&type=script&lang=js"
import style0 from "./addFloorShare.vue?vue&type=style&index=0&id=06c117b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c117b1",
  null
  
)

export default component.exports